import React, { CSSProperties } from 'react';
import { Box, Typography, TypographyProps } from '@mui/material';

interface InfoCardTitleProps extends TypographyProps {
  value: string;
}

export const InfoCardTitle = ({ value, ...rest }: InfoCardTitleProps) => {
  return (
    <Typography color="textSecondary" variant="caption" {...rest} noWrap>
      {value}
    </Typography>
  );
};

export interface InforCardValueProps extends TypographyProps {
  value: string;
}

export const InforCardValue = ({ value, ...rest }: InforCardValueProps) => {
  return (
    <Typography
      color="textSecondary"
      variant="body1"
      fontWeight={'bold'}
      noWrap
      {...rest}
    >
      {value}
    </Typography>
  );
};

export type InfoCardProps = {
  title: string;
  value: string;
  style?: CSSProperties;
};

export const InfoCard = ({ title, value, style = {} }: InfoCardProps) => {
  return (
    <Box
      sx={{
        bgcolor: '#E3F7C9',
        paddingX: 2,
        paddingTop: 3,
        paddingBottom: 2.5,
        borderRadius: 1,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: '100%',
        boxSizing: 'border-box',
        ...style,
      }}
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: {
            xs: 'center',
            sm: 'flex-start',
          },
        }}
      >
        <InfoCardTitle value={title} />
        <InforCardValue value={value} />
      </Box>
    </Box>
  );
};
